/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type EnumMessageType = "inbound" | "outbound" | "%future added value";
export type InfiniteScrollMessagesRefresh_EmbedQueryVariables = {
    ids: Array<string>;
};
export type InfiniteScrollMessagesRefresh_EmbedQueryResponse = {
    readonly messageByIds: ReadonlyArray<{
        readonly _id: string;
        readonly id: string;
        readonly oid_patient: string | null;
        readonly text: string | null;
        readonly type: EnumMessageType | null;
        readonly oid_facility: string | null;
        readonly oid_createdBy: string | null;
        readonly oid_recipient: string | null;
        readonly " $fragmentRefs": FragmentRefs<"ChatMessage_EmbedMessage">;
    } | null> | null;
};
export type InfiniteScrollMessagesRefresh_EmbedQuery = {
    readonly response: InfiniteScrollMessagesRefresh_EmbedQueryResponse;
    readonly variables: InfiniteScrollMessagesRefresh_EmbedQueryVariables;
};



/*
query InfiniteScrollMessagesRefresh_EmbedQuery(
  $ids: [MongoID!]!
) {
  messageByIds(_ids: $ids) {
    _id
    id
    oid_patient
    text
    type
    oid_facility
    oid_createdBy
    oid_recipient
    ...ChatMessage_EmbedMessage
  }
}

fragment AvatarNode_EmbedNode on Node {
  __isNode: __typename
  __typename
  ... on Group {
    groupName: name
  }
  ... on Patient {
    name
    oid_avatar
    isOnline
  }
  ... on Provider {
    name
    oid_avatar
    isOnline
  }
  ... on User {
    name
    oid_avatar
    isOnline
  }
  ... on ChatActivity {
    patient {
      name
      oid_avatar
      isOnline
      id
    }
  }
}

fragment ChatMessage_EmbedMessage on Message {
  automated
  createdAt
  oid_file
  ref
  text
  type
  visibility
  mentions {
    mention
  }
  createdBy(includeDeleted: true) {
    name
    ...AvatarNode_EmbedNode
    id
  }
  patient(includeDeleted: true) {
    name
    ...AvatarNode_EmbedNode
    id
  }
  ...TypographyMessageDetails_EmbedMessage
}

fragment TypographyMessageDetails_EmbedMessage on Message {
  channel
  createdAt
  ref
  secure
  type
  visibility
  to
  facility {
    _id
    name
    id
  }
  media {
    url
  }
  retry {
    count
  }
  notifyTo {
    channel
    to
  }
  status
  externalStatus {
    reason
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ids"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "_ids",
    "variableName": "ids"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "_id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "oid_patient",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "oid_facility",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "oid_createdBy",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "oid_recipient",
  "storageKey": null
},
v10 = [
  {
    "kind": "Literal",
    "name": "includeDeleted",
    "value": true
  }
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "oid_avatar",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isOnline",
  "storageKey": null
},
v14 = [
  (v12/*: any*/),
  (v13/*: any*/)
],
v15 = [
  (v11/*: any*/),
  (v3/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": "groupName",
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "type": "Group",
        "abstractKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": (v14/*: any*/),
        "type": "Patient",
        "abstractKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": (v14/*: any*/),
        "type": "Provider",
        "abstractKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": (v14/*: any*/),
        "type": "User",
        "abstractKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Patient",
            "kind": "LinkedField",
            "name": "patient",
            "plural": false,
            "selections": [
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "type": "ChatActivity",
        "abstractKey": null
      }
    ],
    "type": "Node",
    "abstractKey": "__isNode"
  }
],
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "channel",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "to",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InfiniteScrollMessagesRefresh_EmbedQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Message",
        "kind": "LinkedField",
        "name": "messageByIds",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ChatMessage_EmbedMessage"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InfiniteScrollMessagesRefresh_EmbedQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Message",
        "kind": "LinkedField",
        "name": "messageByIds",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "automated",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "oid_file",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "ref",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "visibility",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MessageMentions",
            "kind": "LinkedField",
            "name": "mentions",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "mention",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v10/*: any*/),
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "createdBy",
            "plural": false,
            "selections": (v15/*: any*/),
            "storageKey": "createdBy(includeDeleted:true)"
          },
          {
            "alias": null,
            "args": (v10/*: any*/),
            "concreteType": "Patient",
            "kind": "LinkedField",
            "name": "patient",
            "plural": false,
            "selections": (v15/*: any*/),
            "storageKey": "patient(includeDeleted:true)"
          },
          (v16/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "secure",
            "storageKey": null
          },
          (v17/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Facility",
            "kind": "LinkedField",
            "name": "facility",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v11/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MessageMedia",
            "kind": "LinkedField",
            "name": "media",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "url",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MessageRetry",
            "kind": "LinkedField",
            "name": "retry",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "count",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MessageNotifyTo",
            "kind": "LinkedField",
            "name": "notifyTo",
            "plural": true,
            "selections": [
              (v16/*: any*/),
              (v17/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MessageExternalStatus",
            "kind": "LinkedField",
            "name": "externalStatus",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "reason",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b62820b224f459ac6f517e1dbe8630cf",
    "id": null,
    "metadata": {},
    "name": "InfiniteScrollMessagesRefresh_EmbedQuery",
    "operationKind": "query",
    "text": "query InfiniteScrollMessagesRefresh_EmbedQuery(\n  $ids: [MongoID!]!\n) {\n  messageByIds(_ids: $ids) {\n    _id\n    id\n    oid_patient\n    text\n    type\n    oid_facility\n    oid_createdBy\n    oid_recipient\n    ...ChatMessage_EmbedMessage\n  }\n}\n\nfragment AvatarNode_EmbedNode on Node {\n  __isNode: __typename\n  __typename\n  ... on Group {\n    groupName: name\n  }\n  ... on Patient {\n    name\n    oid_avatar\n    isOnline\n  }\n  ... on Provider {\n    name\n    oid_avatar\n    isOnline\n  }\n  ... on User {\n    name\n    oid_avatar\n    isOnline\n  }\n  ... on ChatActivity {\n    patient {\n      name\n      oid_avatar\n      isOnline\n      id\n    }\n  }\n}\n\nfragment ChatMessage_EmbedMessage on Message {\n  automated\n  createdAt\n  oid_file\n  ref\n  text\n  type\n  visibility\n  mentions {\n    mention\n  }\n  createdBy(includeDeleted: true) {\n    name\n    ...AvatarNode_EmbedNode\n    id\n  }\n  patient(includeDeleted: true) {\n    name\n    ...AvatarNode_EmbedNode\n    id\n  }\n  ...TypographyMessageDetails_EmbedMessage\n}\n\nfragment TypographyMessageDetails_EmbedMessage on Message {\n  channel\n  createdAt\n  ref\n  secure\n  type\n  visibility\n  to\n  facility {\n    _id\n    name\n    id\n  }\n  media {\n    url\n  }\n  retry {\n    count\n  }\n  notifyTo {\n    channel\n    to\n  }\n  status\n  externalStatus {\n    reason\n  }\n}\n"
  }
};
})();
(node as any).hash = '956762c0bb68fa42e75874e82d9f5054';
export default node;
